import { HOSTING_CONFIG } from '../_Config'

type Platform = 'ios' | 'android' | 'unknown'

export function getPlatform(): Platform {
  let originalDomain = window.location.host
  let userAgent = window.navigator.userAgent
  if (userAgent?.includes('Android')) {
    return 'android'
  } else if (userAgent?.includes('iPhone')) {
    return 'ios'
  } else if (userAgent?.includes('iPad')) {
    return 'ios'
  } else if (originalDomain.includes(HOSTING_CONFIG.ANDROID_DOMAIN)) {
    return 'android'
  } else if (originalDomain.includes(HOSTING_CONFIG.IOS_DOMAIN)) {
    return 'ios'
  }
  return 'unknown'
}
